import React, { Component } from "react";
import ICON from "../icons.js";
import { stripJuristic } from "../../../components/text-sanitize.js";

/* ============================================================================
 * HomePromo — แบนเนอร์โปรโมต (เลื่อนอัตโนมัติ) + การ์ดชวนติดต่อด้านขวา
 *
 * รายการแบนเนอร์แก้ไข/เรียงลำดับ/เปิด-ปิดได้จากหลังบ้าน (section "banner")
 * ไม่มีแบนเนอร์เลย = ไม่แสดงทั้งแถว ดีกว่าโชว์กล่องเปล่าคั่นกลางหน้า
 *
 * ★ การ์ดข้างขวาใช้ข้อความจาก section "contact" (title/body) ของโครงการ
 *   เดิมเป็นข้อความตายตัว "สนใจห้องไหน ติดต่อได้เลย" ที่ผู้ดูแลแก้ไม่ได้
 *   ไม่มีข้อมูล = ไม่แสดงการ์ด แบนเนอร์ขยายเต็มแถวแทน (hm-promo--single)
 * ========================================================================== */
const AUTOPLAY_MS = 6000;

export default class HomePromo extends Component {
    state = { index: 0 };

    slides = () => this.props.banners || [];

    componentDidMount() {
        this.restart();
    }

    componentDidUpdate(prevProps) {
        // แบนเนอร์มาทีหลัง (โหลด API เสร็จ) ให้เริ่มนับจากใบแรกใหม่ และตั้งนาฬิกาตามจำนวนใบใหม่
        if (prevProps.banners !== this.props.banners) {
            this.setState({ index: 0 });
            this.restart();
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    // ★ ตั้งนาฬิกาเฉพาะตอนมีมากกว่า 1 ใบ — ใบเดียวไม่มีอะไรให้เลื่อน ตั้งไว้ก็ render ซ้ำเปล่า ๆ ทุก 6 วินาที
    // ผู้ใช้กดเลื่อนเองก็เรียกตัวนี้ : รีเซ็ตนาฬิกา จะได้ไม่โดนเลื่อนซ้อนทันที
    restart = () => {
        clearInterval(this.timer);
        this.timer = null;
        if (this.slides().length > 1) this.timer = setInterval(this.next, AUTOPLAY_MS);
    };

    go = (index) => {
        const total = this.slides().length;
        if (!total) return;
        this.setState({ index: (index + total) % total });
        this.restart();
    };

    next = () => this.setState((s) => ({ index: (s.index + 1) % Math.max(1, this.slides().length) }));

    render() {
        const { index } = this.state;
        const { onContact, side } = this.props;
        const list = this.slides();
        if (!list.length) return null;

        const sideTitle = stripJuristic(side?.title) || "";
        const sideBody = stripJuristic(side?.subtitle || side?.body) || "";
        const hasSide = !!(sideTitle || sideBody);

        return (
            <div className="hm-container">
                <div className={`hm-promo ${hasSide ? "" : "hm-promo--single"}`}>
                    <div className="hm-banner" aria-roledescription="carousel" aria-label="แบนเนอร์โปรโมชั่น">
                        {list.map((item, i) => (
                            <div key={item.uid} className={`hm-banner__slide ${i === index ? "is-active" : ""}`} aria-hidden={i !== index}>
                                {/* มีรูปต้องมีฉากมืดคลุม ไม่งั้นตัวอักษรสีขาวจมไปกับรูปสว่าง */}
                                {!!item.image_url && (
                                    <>
                                        <img className="hm-banner__bg" src={item.image_url} alt="" aria-hidden="true" loading="lazy" decoding="async" />
                                        <span className="hm-banner__veil" />
                                    </>
                                )}

                                <div className="hm-banner__left">
                                    {!!item.subtitle && <div className="hm-banner__kicker">{item.subtitle}</div>}
                                    <div className="hm-banner__title">{item.title}</div>
                                </div>

                                <div className="hm-banner__right">
                                    <p>{item.body}</p>
                                </div>
                            </div>
                        ))}

                        {list.length > 1 && (
                            <>
                                <button type="button" className="hm-banner__nav is-prev" aria-label="แบนเนอร์ก่อนหน้า" onClick={() => this.go(index - 1)}>
                                    <span className="hm-ico">{ICON.chevron_left}</span>
                                </button>
                                <button type="button" className="hm-banner__nav is-next" aria-label="แบนเนอร์ถัดไป" onClick={() => this.go(index + 1)}>
                                    <span className="hm-ico">{ICON.chevron_right}</span>
                                </button>

                                <div className="hm-banner__dots">
                                    {list.map((item, i) => (
                                        <button
                                            key={`dot-${item.uid}`}
                                            type="button"
                                            aria-label={`แบนเนอร์ที่ ${i + 1}`}
                                            aria-current={i === index}
                                            className={`hm-banner__dot ${i === index ? "is-active" : ""}`}
                                            onClick={() => this.go(i)}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </div>

                    {hasSide && (
                        <div className="hm-promo__side">
                            <div className="hm-side-card hm-side-card--tint">
                                <div className="hm-side-card__body">
                                    {!!sideTitle && <div className="hm-side-card__title">{sideTitle}</div>}
                                    {!!sideBody && <div className="hm-side-card__desc">{sideBody}</div>}
                                    <button type="button" className="hm-btn hm-btn--primary hm-btn--sm" onClick={onContact}>
                                        <span className="hm-ico">{ICON.phone}</span>
                                        ฝากข้อมูลติดต่อกลับ
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
